export default __webpack_public_path__ + "static/media/gnl5.8715f843.webp";